import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
const Badge = ({
  badge,
  imgTagFallbackConfig = { size: 'md', format: 'png', resolution: '1x' },
  onClick
}) => {
  const [sources, setSources] = useState({});
  const [fallbackImgSrc, setFallbackImgSrc] = useState(null);
  const { id, url, images, isLazy, alt } = badge;

  useEffect(() => {
    const getSourceData = () => {
      const imgWebp1x = images.find(
        (image) => image.resolution === '1x' && image.format === 'webp'
      )?.file;
      const imgWebp2x = images.find(
        (image) => image.resolution === '2x' && image.format === 'webp'
      )?.file;
      const imgPng1x = images.find(
        (image) => image.resolution === '1x' && image.format === 'png'
      )?.file;
      const imgPng2x = images.find(
        (image) => image.resolution === '2x' && image.format === 'png'
      )?.file;

      return {
        ...((imgWebp1x || imgWebp2x) && {
          webp: [
            ...(imgWebp1x ? [`${imgWebp1x} 1x`] : []),
            ...(imgWebp2x ? [`${imgWebp2x} 2x`] : [])
          ].join(', ')
        }),
        ...((imgPng1x || imgPng2x) && {
          png: [
            ...(imgPng1x ? [`${imgPng1x} 1x`] : []),
            ...(imgPng2x ? [`${imgPng2x} 2x`] : [])
          ].join(', ')
        })
      };
    };

    const sourceData = getSourceData();

    setSources(sourceData);
  }, [images]);

  useEffect(() => {
    if (!fallbackImgSrc) {
      const defaultImage = images.find(
        (image) =>
          image.resolution === imgTagFallbackConfig.resolution &&
          image.format === imgTagFallbackConfig.format &&
          image.size.id === imgTagFallbackConfig.size
      );

      if (defaultImage?.file) {
        setFallbackImgSrc(defaultImage.file);
      }
    }
  }, [images, imgTagFallbackConfig, fallbackImgSrc]);

  return (
    <a href={url} onClick={() => onClick(id)} data-cy={id}>
      <picture>
        {Object.entries(sources).map(([key, value]) => (
          <source
            key={`badge-${key}`}
            data-testid={`badge-${key}`}
            srcSet={value}
            type={`image/${key}`}
          />
        ))}
        <img
          src={fallbackImgSrc}
          loading={isLazy ? 'lazy' : 'eager'}
          alt={alt}
          height="35"
          width="105"
        />
      </picture>
    </a>
  );
};

Badge.propTypes = {
  badge: PropTypes.shape({
    id: PropTypes.string.isRequired,
    url: PropTypes.string,
    images: PropTypes.arrayOf(
      PropTypes.shape({
        file: PropTypes.string,
        format: PropTypes.string,
        resolution: PropTypes.string,
        size: PropTypes.shape({
          id: PropTypes.string,
          value: PropTypes.string,
          minVw: PropTypes.string
        })
      })
    ),
    isLazy: PropTypes.bool,
    alt: PropTypes.string
  }).isRequired,
  imgTagFallbackConfig: PropTypes.shape({
    size: PropTypes.oneOf(['xs', 'sm', 'md', 'lg']),
    format: PropTypes.oneOf(['png', 'webp']),
    resolution: PropTypes.oneOf(['1x', '2x'])
  }),
  onClick: PropTypes.func.isRequired
};

Badge.defaultProps = {
  imgTagFallbackConfig: undefined
};

export default Badge;
